import { useMemo } from "react";
import { useSelector } from "react-redux";
import { State } from "@/redux/Types";

/**
 * True when the user is in an Outgrow-embedded session (Ubuntu UI, blue accents).
 * Uses Redux, cbb token, and localStorage — EntryOutgrow sets `outgrow` in localStorage
 * and may not always persist `fromOutgrow` identically after reload.
 */
export function useOutgrowSession(): boolean {
  const fromOutgrow = useSelector((state: State) => state.user.fromOutgrow);
  const cbbToken = useSelector(
    (state: State) => state.user.outgrowData?.cbbToken,
  );

  return useMemo(() => {
    if (fromOutgrow) return true;
    if (cbbToken) return true;
    try {
      return typeof window !== "undefined"
        ? window.localStorage.getItem("outgrow") === "true"
        : false;
    } catch {
      return false;
    }
  }, [fromOutgrow, cbbToken]);
}
